import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Flex } from 'nallian-shared-ui/lib/components';
import IdentityAutoCompleteValueComponent from './IdentityAutoComplete';
import linkIdentityService from '../../../services/principals/linkIdentityService';

const TypeAheadLink = ({
  principalId,
  dispatchLinkIdentityPost,
  linkIdentityFetch,
  handleRefetchSecurityContext,
  disabled,
}) => {
  const { t } = useTranslation();

  const handleLink = useCallback(
    (value, callback) => {
      if (value)
        dispatchLinkIdentityPost(
          principalId,
          { identityId: value },
          () => {
            callback();
            handleRefetchSecurityContext();
          },
          t
        );
    },
    [t, handleRefetchSecurityContext, dispatchLinkIdentityPost, principalId]
  );

  return (
    <Flex fluid direction="column">
      <Flex fluid direction="column" margin="0.5rem 0 0">
        <IdentityAutoCompleteValueComponent
          disabled={disabled}
          onChange={handleLink}
          loading={linkIdentityFetch.pending}
          placeholder={t('searchForAnIdentityOrAddClientId')}
        />
      </Flex>
    </Flex>
  );
};

TypeAheadLink.propTypes = {
  principalId: PropTypes.string.isRequired,
  dispatchLinkIdentityPost: PropTypes.func.isRequired,
  linkIdentityFetch: PropTypes.object.isRequired,
  handleRefetchSecurityContext: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default linkIdentityService(TypeAheadLink);
